import React from 'react';
import { Link } from 'react-router-dom';
import { Send, Instagram } from 'lucide-react';

const Footer = () => {
  const year = new Date().getFullYear();
  const socials = [
    { href: 'https://t.me/reddyannabookofficial', label: 'Telegram', Icon: Send },
    { href: 'https://instagram.com/reddyannabookofficial', label: 'Instagram', Icon: Instagram },
  ];

  const sportLinks = [
    { to: '/cricket', label: 'Cricket' },
    { to: '/soccer', label: 'Football' },
    { to: '/tennis', label: 'Tennis' },
    { to: '/basketball', label: 'Basketball' },
    { to: '/kabaddi', label: 'Kabaddi' },
  ];

  const supportLinks = [
    { to: '/rules', label: 'About Us' },
    { to: '/rules', label: 'Rules' },
    { to: '/rules', label: 'Responsible Gaming' },
    { to: '/rules', label: 'Contact Us' },
    { to: '/rules', label: 'FAQ' },
    { to: '/rules', label: 'Terms' },
  ];

  return (
    <footer
      className="shrink-0 mt-8"
      style={{ background: '#0a0a0a', color: '#d1d5db', padding: '32px 16px 16px' }}
    >
      <div className="max-w-7xl mx-auto">
        {/* Top: 4-column grid on desktop, stacked on mobile */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-6">
          {/* Column 1 — Brand */}
          <div>
            <img
              src="/images/reddyannabook.png"
              alt="REDDY ANNA BOOK"
              className="h-12 w-auto object-contain mb-4"
              style={{ maxWidth: 200 }}
            />
            <p
              className="mb-4"
              style={{ fontSize: 13, color: '#9ca3af', maxWidth: 250, lineHeight: 1.5 }}
            >
              The Best Online Sports Betting Exchange
            </p>
            <div className="flex items-center gap-2">
              {socials.map(({ href, label, Icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="kabook-footer-social flex items-center justify-center"
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: 9999,
                    background: '#f59e0b',
                    color: '#ffffff',
                  }}
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Column 2 — Sports */}
          <div>
            <h3
              className="uppercase"
              style={{ color: '#fbbf24', fontWeight: 700, fontSize: 14, marginBottom: 12 }}
            >
              Sports
            </h3>
            <ul className="list-none p-0 m-0 space-y-1.5">
              {sportLinks.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    className="hover:text-white transition-colors"
                    style={{ color: '#d1d5db', fontSize: 13 }}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 — Support */}
          <div>
            <h3
              className="uppercase"
              style={{ color: '#fbbf24', fontWeight: 700, fontSize: 14, marginBottom: 12 }}
            >
              Support
            </h3>
            <ul className="list-none p-0 m-0 space-y-1.5">
              {supportLinks.map((l, i) => (
                <li key={i}>
                  <Link
                    to={l.to}
                    className="hover:text-white transition-colors"
                    style={{ color: '#d1d5db', fontSize: 13 }}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4 — Quick Actions */}
          <div>
            <h3
              className="uppercase"
              style={{ color: '#fbbf24', fontWeight: 700, fontSize: 14, marginBottom: 12 }}
            >
              Quick Actions
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <Link
                to="/register"
                className="text-center font-semibold"
                style={{
                  background: '#f59e0b',
                  color: '#ffffff',
                  padding: '8px 14px',
                  borderRadius: 6,
                  fontSize: 13,
                }}
              >
                Register Now
              </Link>
              <Link
                to="/deposit"
                className="text-center font-semibold"
                style={{
                  background: 'transparent',
                  color: '#f59e0b',
                  padding: '7px 14px',
                  borderRadius: 6,
                  fontSize: 13,
                  border: '1.5px solid #f59e0b',
                }}
              >
                Deposit
              </Link>
            </div>
          </div>
        </div>

        {/* Separator */}
        <div style={{ height: 1, background: '#374151', margin: '24px 0 16px' }} />

        {/* Legal text */}
        <p style={{ fontSize: 10, color: '#6b7280', lineHeight: 1.5, marginBottom: 16 }}>
          REDDY ANNA BOOK is a limited liability company incorporated under the laws of Curacao. Players
          are requested not to contact any untrusted sources for REDDY ANNA BOOK accounts. This is an
          online site and users can only register independently without any agents. Only deposit
          through the account details generated by the system.
        </p>

        {/* Bottom row */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <span style={{ fontSize: 12, color: '#9ca3af' }}>
            &copy; {year} REDDY ANNA BOOK. All Rights Reserved.
          </span>
          <span
            className="inline-flex items-center gap-1.5"
            style={{ fontSize: 12, color: '#9ca3af' }}
          >
            <span
              className="inline-flex items-center justify-center"
              style={{
                background: '#f59e0b',
                color: '#0a0a0a',
                fontWeight: 800,
                fontSize: 10,
                padding: '1px 6px',
                borderRadius: 4,
                letterSpacing: 0.5,
              }}
            >
              18+
            </span>
            Only | Play Responsibly
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
